export const Filter = [
	{
		id: '10',
		name: 'Estado',
	},
	{
		id: '1',
		name: 'Todos',
	},
	{
		id: '2',
		name: 'En Edición',
	},
	{
		id: '3',
		name: 'Descartadas',
	},
	{
		id: '10',
		name: 'Modalidad',
	},
	{
		id: '4',
		name: 'Todas',
	},
	{
		id: '5',
		name: 'Catálogo',
	},
	{
		id: '6',
		name: 'Oferta',
	},
	{
		id: '10',
		name: 'Canal',
	},
	{
		id: '7',
		name: 'Todos',
	},
	{
		id: '8',
		name: 'Moderno',
	},
	{
		id: '9',
		name: 'Tradicional',
	},
]
